import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { to: '/category/common-tools', label: '常用工具' },
      { to: '/category/shopping', label: '购物消费' },
      { to: '/category/social-entertainment', label: '社交娱乐' },
      { to: '/category/learning', label: '学习资源' },
      { to: '/category/news-media', label: '新闻资讯' },
    ],
  },
  {
    title: '更多分类',
    links: [
      { to: '/category/design-creative', label: '设计创意' },
      { to: '/category/dev-tech', label: '开发技术' },
      { to: '/category/life-service', label: '生活服务' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/articles', label: '推荐文章' },
      { to: '/about', label: '联系方式' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-3-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                草莓导航
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              精选网站导航入口，一站直达优质资源。
              告别繁琐搜索，高效畅游互联网世界。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 草莓导航 - 精选网站导航入口
          </p>
          <div className="flex items-center gap-4 text-sm text-background-500">
            <span>友情链接：</span>
            <a href="https://www.google.com" target="_blank" rel="nofollow noopener" className="hover:text-primary-400 transition-colors">Google</a>
            <a href="https://www.baidu.com" target="_blank" rel="nofollow noopener" className="hover:text-primary-400 transition-colors">百度</a>
          </div>
        </div>
      </div>
    </footer>
  );
}